/** Only same-app paths are valid redirect targets after login (no open redirect). */
export function safeRedirect(raw: unknown): string {
  const v = Array.isArray(raw) ? raw[0] : raw;
  if (typeof v !== 'string' || !v.startsWith('/') || v.startsWith('//') || v.startsWith('/\\') || v.startsWith('/login')) return '/';
  return v;
}
